import React from 'react';
import imageSrc from 'assets/cancel-subscription.png';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useHistory } from 'react-router-dom';
import { SettingsRoutes } from '../../routes/settings-routes';

export const useOpenConditionalDowngradeModal = () => {
  const { openConfirmFbDowngradeModal, openNewInfoModal, closeModal } =
    useModalActions();

  const history = useHistory();

  const downgradeWithCS = {
    title: 'Cancel my Subscription',
    description: (
      <div>
        Please contact support at{''}{' '}
        <a
          className="pause-subscription-modal-link"
          href="mailto:cs@customers.ai"
        >
          cs@customers.ai
        </a>
        <br />
        to cancel your subscription
      </div>
    ),
    image: imageSrc,
    button: 'Ok',
    onClick: () => closeModal(),
  };

  const openConditionalDowngradeModal = (
    ...args: Parameters<typeof openConfirmFbDowngradeModal>
  ) => {
    const modalProps = args[0];
    const { plan, facebookPage, tabId } = modalProps;

    // Note: facebookPage and tabId will not be defined for team subscriptions
    // But we anyway do not want them to be able to cancel on their own.
    if (plan.cancellableInUi && tabId && facebookPage) {
      history.push(
        SettingsRoutes.billing.cancel.getLink(tabId, facebookPage?.id),
      );
      return null;
    }

    return openNewInfoModal(downgradeWithCS);
  };

  return {
    openConditionalDowngradeModal,
  };
};
